module.exports = __webpack_public_path__ + "00154ccc517b3945df96aacba67cc1ff.png";